var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPvxLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 39,
    viewBox: "0 0 223 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8089 6.98828L14.4623 7.75768V18.9839L18.9109 17.6204C20.0388 17.2747 20.8089 16.2333 20.8089 15.0536V6.98828Z",
    fill: "url(#paint0_linear_5312_12367)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21797 8.50556C6.95286 8.65575 6 9.72841 6 11.0024V25.0689L10.631 23.7069C11.7736 23.3709 12.5582 22.3223 12.5582 21.1313V7.99032L8.21797 8.50556Z",
    fill: "url(#paint1_linear_5312_12367)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3672 32.0143L21.7138 31.2449V20.0186L17.2651 21.3821C16.1373 21.7278 15.3672 22.7693 15.3672 23.9489V32.0143Z",
    fill: "url(#paint2_linear_5312_12367)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3672 32.0143L21.7138 31.2449V20.0186L17.2651 21.3821C16.1373 21.7278 15.3672 22.7693 15.3672 23.9489V32.0143Z",
    fill: "url(#paint3_linear_5312_12367)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3672 32.0143L21.7138 31.2449V20.0186L17.2651 21.3821C16.1373 21.7278 15.3672 22.7693 15.3672 23.9489V32.0143Z",
    fill: "#DDEFEF",
    fillOpacity: 0.53
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.958 30.497C29.2231 30.3468 30.1759 29.2741 30.1759 28.0001V13.9336L25.5449 15.2956C24.4024 15.6317 23.6178 16.6803 23.6178 17.8712V31.0122L27.958 30.497Z",
    fill: "url(#paint4_linear_5312_12367)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.958 30.497C29.2231 30.3468 30.1759 29.2741 30.1759 28.0001V13.9336L25.5449 15.2956C24.4024 15.6317 23.6178 16.6803 23.6178 17.8712V31.0122L27.958 30.497Z",
    fill: "url(#paint5_linear_5312_12367)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.958 30.497C29.2231 30.3468 30.1759 29.2741 30.1759 28.0001V13.9336L25.5449 15.2956C24.4024 15.6317 23.6178 16.6803 23.6178 17.8712V31.0122L27.958 30.497Z",
    fill: "#DDEFEF",
    fillOpacity: 0.53
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.839 28.6245C196.976 28.6245 195.079 28.0467 193.147 26.8911V23.8124C193.802 24.3643 194.656 24.8731 195.708 25.3388C196.76 25.8045 197.804 26.0373 198.839 26.0373C199.58 26.0373 200.184 25.8994 200.65 25.6234C201.133 25.3474 201.374 24.9766 201.374 24.5109C201.374 24.0625 201.107 23.7003 200.572 23.4243C200.037 23.1311 199.132 22.8465 197.856 22.5705C196.165 22.2083 194.915 21.7254 194.104 21.1217C193.311 20.5008 192.914 19.6556 192.914 18.5863C192.914 17.3099 193.449 16.3096 194.518 15.5851C195.587 14.8435 196.907 14.4727 198.477 14.4727C200.184 14.4727 201.943 14.9728 203.754 15.9732V18.7156C201.857 17.5945 200.098 17.034 198.477 17.034C197.735 17.034 197.123 17.1806 196.64 17.4738C196.157 17.7497 195.915 18.1206 195.915 18.5863C195.915 18.707 195.932 18.8191 195.967 18.9226C196.001 19.0261 196.062 19.121 196.148 19.2072C196.234 19.2762 196.321 19.3452 196.407 19.4142C196.493 19.4832 196.614 19.5521 196.769 19.6211C196.941 19.6729 197.088 19.7246 197.209 19.7764C197.347 19.8281 197.528 19.8799 197.752 19.9316C197.994 19.9833 198.192 20.0351 198.347 20.0868C198.52 20.1213 198.752 20.1731 199.046 20.2421C199.356 20.2938 199.606 20.3455 199.796 20.3973C201.417 20.7767 202.581 21.3114 203.289 22.0013C203.996 22.674 204.349 23.5192 204.349 24.5368C204.349 25.8994 203.815 26.9256 202.745 27.6155C201.676 28.2882 200.374 28.6245 198.839 28.6245Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M183.156 28.4165V14.7045H186.132V17.3381C186.563 16.4757 187.227 15.4461 188.124 15.0149C189.021 14.5665 190.116 14.4458 191.409 14.6527V17.8091C190.012 17.3779 188.779 17.5159 187.71 18.223C186.658 18.9302 186.132 20.0082 186.132 21.457V28.4165H183.156Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M174.318 28.6245C172.352 28.6245 170.688 27.9346 169.325 26.5548C167.963 25.1577 167.281 23.4847 167.281 21.5357C167.281 19.5694 167.971 17.905 169.351 16.5424C170.731 15.1626 172.387 14.4727 174.318 14.4727C176.026 14.4727 177.526 15.0332 178.82 16.1543C180.131 17.2582 180.933 18.6466 181.226 20.3197C181.399 21.1303 181.407 21.9065 181.252 22.6481H170.231C170.403 23.6658 170.869 24.4764 171.628 25.0801C172.387 25.6665 173.284 25.9597 174.318 25.9597C175.905 25.9597 177.173 25.3992 178.122 24.2781L180.76 24.9766C180.209 26.0805 179.329 26.9687 178.122 27.6414C176.914 28.2968 175.646 28.6245 174.318 28.6245ZM170.231 20.3455H178.329C178.156 19.4314 177.699 18.6639 176.957 18.043C176.233 17.422 175.345 17.1116 174.292 17.1116C173.24 17.1116 172.343 17.4307 171.602 18.0688C170.86 18.6898 170.403 19.4487 170.231 20.3455Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.461 28.4175V14.7055H155.436V16.8993C156.488 15.5367 157.911 14.4727 159.705 14.4727C161.275 14.4727 162.62 14.9815 163.741 15.9991C164.879 16.9995 165.449 18.3362 165.449 20.0092V28.4175H162.473V20.8112C162.473 19.7074 162.146 18.8364 161.49 18.1982C160.852 17.56 160.067 17.2409 159.136 17.2409C158.049 17.2409 157.161 17.6376 156.471 18.431C155.781 19.2072 155.436 20.1817 155.436 21.3546V28.4175H152.461Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.441 28.3103C148.319 28.8967 146.577 28.8104 145.215 28.0515C143.852 27.2926 143.171 25.9387 143.171 23.9897L143.197 17.263H140.609V14.7017H143.197L143.222 11.3125H146.146V14.7017H150.337V17.263H146.146L146.12 23.9638C146.12 24.8089 146.474 25.3781 147.181 25.6713C147.888 25.9645 148.975 25.8869 150.441 25.4385V28.3103Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.102 28.4165V14.7045H134.077V17.3381C134.508 16.4757 135.172 15.4461 136.069 15.0149C136.966 14.5665 138.061 14.4458 139.355 14.6527V17.8091C137.958 17.3779 136.724 17.5159 135.655 18.223C134.603 18.9302 134.077 20.0082 134.077 21.457V28.4165H131.102Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.045 28.6245C120.441 28.6245 119.855 28.5555 119.286 28.4175C118.734 28.2796 118.199 28.064 117.682 27.7708C117.164 27.4603 116.742 27.0205 116.414 26.4513C116.086 25.8649 115.922 25.1836 115.922 24.4074C115.905 23.0103 116.388 21.9496 117.371 21.2252C118.354 20.4835 119.76 20.1127 121.588 20.1127H125.754V19.2848C125.754 18.5259 125.443 17.9567 124.822 17.5773C124.201 17.1806 123.399 16.9822 122.416 16.9822C120.536 16.9822 119.441 17.6031 119.13 18.845L116.285 18.8967C116.319 17.5341 116.914 16.4562 118.07 15.6628C119.243 14.8694 120.674 14.4727 122.364 14.4727C124.072 14.4727 125.529 14.8866 126.737 15.7145C127.961 16.5424 128.574 17.6118 128.574 18.9226V28.4175H125.754V26.3478C125.357 26.8997 124.753 27.4172 123.943 27.9001C123.149 28.383 122.183 28.6245 121.045 28.6245ZM121.278 26.1667C122.416 26.1667 123.442 25.7786 124.357 25.0025C125.288 24.2263 125.754 23.3122 125.754 22.2601H122.106C120.985 22.2601 120.148 22.4757 119.596 22.9069C119.061 23.3208 118.829 23.8469 118.898 24.485C118.949 25.0715 119.208 25.5027 119.674 25.7786C120.139 26.0373 120.674 26.1667 121.278 26.1667Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 28.4149V10.3047H108.806C110.548 10.3047 111.997 10.8997 113.153 12.0898C114.308 13.2627 114.886 14.6856 114.886 16.3587C114.886 18.049 114.308 19.4719 113.153 20.6275C112.015 21.7659 110.566 22.3437 108.806 22.3609L103.829 22.3868V28.4149H100.75ZM103.829 19.6185L108.599 19.5927C109.6 19.5927 110.402 19.2736 111.006 18.6354C111.609 17.98 111.911 17.1866 111.911 16.2552C111.911 15.3411 111.609 14.5822 111.006 13.9785C110.419 13.3748 109.617 13.073 108.599 13.073L103.829 13.0988V19.6185Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9531 28.4149L81.1106 19.3598L74.9531 10.3047H78.5234L83.3356 17.5488L88.1477 10.3047H91.7439L85.5347 19.3598L91.7439 28.4149H88.1477L83.3356 21.1708L78.5234 28.4149H74.9531Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9963 28.4152L60.4688 14.7031H63.651L67.4283 26.899L71.2055 14.7031H74.3878L69.8861 28.4152H64.9963Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1719 28.4149V10.3047H52.2283C53.9703 10.3047 55.4191 10.8997 56.5747 12.0898C57.7303 13.2627 58.3081 14.6856 58.3081 16.3587C58.3081 18.049 57.7303 19.4719 56.5747 20.6275C55.4364 21.7659 53.9876 22.3437 52.2283 22.3609L47.2506 22.3868V28.4149H44.1719ZM47.2506 19.6185L52.0213 19.5927C53.0217 19.5927 53.8237 19.2736 54.4274 18.6354C55.0311 17.98 55.3329 17.1866 55.3329 16.2552C55.3329 15.3411 55.0311 14.5822 54.4274 13.9785C53.841 13.3748 53.0389 13.073 52.0213 13.073L47.2506 13.0988V19.6185Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5312_12367",
    x1: 6,
    y1: 22.4926,
    x2: 44.2859,
    y2: 0.432359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5312_12367",
    x1: 6,
    y1: 22.4926,
    x2: 44.2859,
    y2: 0.432359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5312_12367",
    x1: 10.5066,
    y1: 32.0058,
    x2: 65.5505,
    y2: 10.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5312_12367",
    x1: 30.176,
    y1: 16.51,
    x2: -8.10971,
    y2: 38.5699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5312_12367",
    x1: 10.5066,
    y1: 32.0058,
    x2: 65.5505,
    y2: 10.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5312_12367",
    x1: 30.176,
    y1: 16.51,
    x2: -8.10971,
    y2: 38.5699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvxLogoFull);
export default __webpack_public_path__ + "static/media/pvx-logo-full.e01893ac6b93aca4c0e64b419caa4458.svg";
export { ForwardRef as ReactComponent };